import { render, staticRenderFns } from "./goods-description.vue?vue&type=template&id=1a04a6c9&"
import script from "./goods-description.vue?vue&type=script&lang=js&"
export * from "./goods-description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports